import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils'
import modelToMesh from "./modelToMesh";

const addFacingTop = async (_model, elementBbox, heightOnEarth) => {

    let model = await modelToMesh(_model)

    let finalGroup = new THREE.Group();
    let lineGroup = new THREE.Group();

    const sinkH = 0.00001;
    const dopusk = 0.00001;
    const napusk = 0;

    const bboxModel = getPosInfo(model);
    const xSize = elementBbox.xSize + napusk * 2;
    const zSize = elementBbox.zSize + napusk * 2;

    const countInWidth = xSize / bboxModel.xSize;
    const countInWidthInt = Math.trunc(countInWidth);
    const countInWidthFract = countInWidth - countInWidthInt;

    const countInLength = zSize / bboxModel.zSize;
    const countInLengthInt = Math.trunc(countInLength);
    const countInLengthFract = countInLength - countInLengthInt;

    model.position.set(
        elementBbox.bbox.min.x + bboxModel.xSize / 2 - napusk,
        heightOnEarth + bboxModel.ySize / 2,
        elementBbox.bbox.min.z + bboxModel.zSize / 2 - napusk
    );

    model.updateMatrix();


    //Создаем полосу в ширину
    lineGroup.add(model);

    for (let index = 2; index <= countInWidthInt; index++) {
        const newModel = SkeletonUtils.clone(model);
        newModel.position.x += (index - 1) * bboxModel.xSize;
        newModel.updateMatrix();
        lineGroup.add(newModel);
        lineGroup.updateMatrix();
    }

    if (countInWidthFract > dopusk) {
        const newModel = SkeletonUtils.clone(model);
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.position.x -= bboxModel.xSize - bboxModel.xSize * countInWidthFract;
        newModel.position.y -= sinkH;
        newModel.updateMatrix();
        lineGroup.add(newModel);
        lineGroup.updateMatrix();
    }
    finalGroup.add(lineGroup); // добавили 1ую линию

    for (let index = 2; index <= countInLengthInt; index++) {
        const newLineGroup = lineGroup.clone();

        newLineGroup.position.z += (index - 1) * bboxModel.zSize;
        newLineGroup.updateMatrix();
        finalGroup.add(newLineGroup);
        finalGroup.updateMatrix();
    }
    if (countInLengthFract > dopusk) {
        const newLineGroup = lineGroup.clone();

        newLineGroup.position.z += countInLengthInt * bboxModel.zSize;
        newLineGroup.position.z -= bboxModel.zSize - bboxModel.zSize * countInLengthFract;
        newLineGroup.position.y -= sinkH;
        newLineGroup.position.z -= sinkH;
        newLineGroup.updateMatrix();
        finalGroup.add(newLineGroup);
    }

    finalGroup.updateMatrix();


    return finalGroup;



}
export default addFacingTop;
